import {
  arrayOf,
  shape,
  string,
  number
} from 'prop-types';

const taxes = arrayOf(shape({
  type: string,
  value: number,
  percentage: number
}));

const fees = arrayOf(shape({
  type: string,
  value: number,
  percentage: number,
  taxTotal: number,
  taxPercentage: number,
  taxes
}));

const tools = arrayOf(shape({
  categoryCode: string,
  subCategoryCode: string,
  deposit: number,
  feeTotal: number,
  taxTotal: number,
  taxPercentage: number,
  fees
}));

export const suppliedEstimateData = shape({
  fees,
  tools
});